{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izvēlēties vienumu",
  "tableResizer": "Izmēra mainītājs",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
